import { defineComponent as a, computed as o } from "vue";
import c from "./index6.js";
import g from "./index7.js";
import i from "./index8.js";
import { SiteConfigTrustLogosFactory as l } from "../types/index4.js";
const B = a({
  name: "TrustLogos",
  components: {
    LogoSSL: i,
    LogoPCI: g,
    LogoBBB: c
  },
  props: {
    config: {
      type: Object,
      required: !0
    },
    isSimpleLogo: {
      type: Boolean,
      default: !1
    },
    isSelectionStyle: {
      type: Boolean,
      default: !1
    }
  },
  setup(t) {
    const e = o(
      () => new l(t.config)
    ), r = o(
      () => e.value.createLogoBBB()
    ), n = o(
      () => e.value.createLogoSSL()
    ), s = o(
      () => e.value.createLogoPCI()
    );
    return {
      logoBBB: r,
      logoSSL: n,
      logoPCI: s
    };
  }
});
export {
  B as default
};
//# sourceMappingURL=index4.js.map
